import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import './main.less';
import { actions, selectors } from './';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';
import { selectors as rootSelectors } from '../root';
import Calendar from '../shared/calendar/main';

import StartTable from './components/table-start/main';
import DropTable from './components/table-drop/main';
import { Tabs, Pane } from '../shared/tabs';
import Filters from '../shared/filters/main';

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content affiliate-managers-productivity">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">{props.intl('Traffic accounting')}</h1>
					</div>
				</div>
				<div className="container__content-body">
					<div className="ui-control-bar">
						<div className="ui-control-bar__item modify-item---calendar">
							<div className="ui-control-bar__item-position">
								<Calendar
									{...props.calendar}
									onInit={props.calendarInit}
									onToggle={props.calendarToggle}
									onChange={props.calendarChange}
									onApply={props.calendarApply}
									intl={props.intl}
								/>
							</div>
						</div>
						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								<button className="ui-btn ui-btn-primary apply" onClick={props.apply}>
									{props.intl('Apply')}
								</button>
								<button className="ui-btn ui-btn-secondary ui-icon-clear" onClick={props.clear} />
							</div>
						</div>
					</div>
					<div className="traffic-accounting__table-position">
						<div className="traffic-accounting__filter-position clearfix">
							<Filters {...props} {...props.filters} />
						</div>
						<Tabs selected={props.currentTab} onTabChange={props.changeTab}>
							<Pane
								label={props.intl('Traffic start')}
								index="traffic-start"
								isVisible={true}
							>
								<div className="padding-10-15 display-flex">
									<ul className="padding-10-15">
										<li>
											- Affiliate without <b>any approved or rejected </b>
											conversions for <b> 30 days</b> prior to date.
										</li>
										<li>- Affiliate has <b>at least one approved or rejected conversion</b> during start date</li>
									</ul>
									<div className="padding-10-15">
										<button
											className="ui-btn ui-btn-primary apply"
											onClick={props.tableExport.bind(null, 'traffic-start')}
										>
											{props.intl('Export')}
										</button>
									</div>
								</div>
								<StartTable {...props} table={props.startTable}/>
							</Pane>
							<Pane
								label={props.intl('Traffic drop')}
								index="traffic-drop"
								isVisible={true}
							>
								<div className="padding-10-15 display-flex">
									<ul className="padding-10-15">
										<li>
											- Average approve count during <b>3 days</b> prior to the date more then <b>30 leads</b>
										</li>
										<li>
											- Approve at the date is less then <b>80%</b> from
											average approve count during <b>3 days</b> prior to the date
										</li>
									</ul>
									<div className="padding-10-15">
										<button
											className="ui-btn ui-btn-primary apply"
											onClick={props.tableExport.bind(null, 'traffic-stop')}
										>
											{props.intl('Export')}
										</button>
										<button
											className="ui-btn ui-btn-primary apply margin-0-15"
											onClick={props.toggleStartFrom10Approves}
										>
											{props.intl('Toggle 10 approves filter')}
										</button>
									</div>
								</div>
								<DropTable {...props} table={props.dropTable}/>
							</Pane>
						</Tabs>
					</div>
				</div>
			</div>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		can: selectors.getCan(state),
		data: selectors.getData(state),
		uncoveredAdmins: selectors.getUncoveredAdmins(state),
		uncoveredAffiliates: selectors.getUncoveredAffiliates(state),
		activeRowNumber: selectors.activeRowNumber(state),
		firstConversionDates: selectors.getFirstConversionDates(state),
		filters: selectors.getFilters(state),
		isToggledStartFrom10Approves: selectors.getIsToggledStartFrom10Approves(state),
		startTable: selectors.getStartTable(state),
		dropTable: selectors.getDropTable(state),
		currentTab: selectors.getCurrentTab(state),
		calendar: selectors.getCalendar(state),
		intl: selectors.getIntl(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		progressBar: selectors.getProgressBar(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/traffic-accounting/main.js